import {
  PublicClientApplication,
  Configuration,
  PopupRequest,
} from '@azure/msal-browser';

/**
 * Configuration for the Azure AD authentication provider.
 */
const msalConfig: Configuration = {
  auth: {
    clientId: `${process.env.REACT_APP_MICROSOFT_CLIENT_ID}`,
    authority:
      'https://login.microsoftonline.com/b1a7c303-0faf-4874-a764-0eb184efd96e',
    redirectUri: `${window.location.origin}/login`,
    // postLogoutRedirectUri: `${window.location.origin}`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

/**
 * Authentication parameters for requesting specific scopes.
 */
export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Options for configuring the authentication behavior.
 */
export const initializeMsal = async (): Promise<void> => {
  await msalInstance.initialize();
};
export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
  prompt: 'select_account',
  popupWindowAttributes: {
    popupSize: {
      width: 600,
      height: 700,
    },
    popupPosition: {
      top: 0,
      left: 0,
    },
  },
};
